'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Url = require('urlinator/Url');

var _Url2 = _interopRequireDefault(_Url);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _reactRouterDom = require('react-router-dom');

var _UISimpleAvatar = require('ui-addon-avatars/UISimpleAvatar');

var _UISimpleAvatar2 = _interopRequireDefault(_UISimpleAvatar);

var _UIPopover = require('UIComponents/tooltip/UIPopover');

var _UIPopover2 = _interopRequireDefault(_UIPopover);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _growthhub = require('bender-url!../../img/growthhub.svg');

var _growthhub2 = _interopRequireDefault(_growthhub);

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var APP_HUBSPOT = function () {
  var env = _enviro2.default.isQa() ? 'qa' : '';
  return 'https://app.hubspot' + env + '.com';
}();

var buildLoginUrl = function buildLoginUrl() {
  var params = { loginRedirectUrl: location.href };
  return new _Url2.default('/login', { lb: 'app', params: params }).href;
};

var Navigation = function (_Component) {
  _inherits(Navigation, _Component);

  function Navigation(props) {
    _classCallCheck(this, Navigation);

    var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));

    _this.state = { open: false };
    _this.onOpenChange = _this.onOpenChange.bind(_this);
    _this.onProfileClick = _this.onProfileClick.bind(_this);
    return _this;
  }

  _createClass(Navigation, [{
    key: 'onOpenChange',
    value: function onOpenChange(event) {
      this.setState({ open: event.target.value });
    }
  }, {
    key: 'onProfileClick',
    value: function onProfileClick() {
      this.setState({ open: !this.state.open });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          booted = _props.booted,
          auth = _props.auth,
          user = _props.user;

      if (!booted) {
        return null;
      }
      var loggedInExtras = [];
      var search = null;
      // const search = (
      //   <Link to="/search" className="search">
      //     <UIIcon name="search" />
      //   </Link>
      // );
      var personalInnards = void 0;
      if (booted && !auth.id) {
        personalInnards = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _UIButton2.default,
            { use: 'primary', href: buildLoginUrl() },
            'Log in'
          )
        );
      } else {
        var link = void 0;
        if (auth.id === (user && user.id)) {
          link = _react2.default.createElement(
            'span',
            null,
            'My Profile'
          );
        } else {
          link = '/users/' + auth.id;
          if (auth.username) {
            link = '/' + auth.username;
          }
          link = _react2.default.createElement(
            _reactRouterDom.Link,
            { to: link, className: 'profile' },
            'My Profile'
          );
        }
        // loggedInExtras.push(
        //   <Link key="settings" to="/settings" className="settings">
        //     <UIIcon name="settings" />
        //   </Link>
        // );
        // loggedInExtras.push(
        //   <Link key="notifications" to="/notifications" className="notifications">
        //     <UIIcon name="notification" />
        //   </Link>
        // );
        var here = encodeURIComponent(window.location.href);
        var logoutUrl = APP_HUBSPOT + '/login-api/v1/logout/all?redirectUrl=' + here;
        personalInnards = _react2.default.createElement(
          _UIPopover2.default,
          {
            open: this.state.open,
            closeOnOutsideClick: true,
            onOpenChange: this.onOpenChange,
            placement: 'bottom left',
            className: 'profile-dropdown',
            content: {
              body: _react2.default.createElement(
                'div',
                { className: 'wrapper' },
                link,
                _react2.default.createElement(
                  'a',
                  { href: APP_HUBSPOT + '/l/dash' },
                  'HubSpot Software'
                ),
                _react2.default.createElement(
                  'a',
                  { href: APP_HUBSPOT + '/l/certification' },
                  'Learning Center'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'extra' },
                  _react2.default.createElement(
                    'a',
                    { href: logoutUrl },
                    'Sign out'
                  ),
                  _react2.default.createElement(
                    'a',
                    { href: 'https://legal.hubspot.com/community-tou' },
                    'Terms of service'
                  )
                )
              )
            }
          },
          _react2.default.createElement(
            'a',
            { className: 'personal', onClick: this.onProfileClick },
            _react2.default.createElement(_UISimpleAvatar2.default, { src: auth.avatarUrl + '/32', size: 'sm' }),
            _react2.default.createElement(_UIIcon2.default, { name: 'down' })
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'nav-container' },
        _react2.default.createElement(
          'nav',
          null,
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/', className: 'brand' },
            _react2.default.createElement(_UIImage2.default, { src: _growthhub2.default })
          ),
          _react2.default.createElement('div', { className: 'separator' }),
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/members' },
            'Members'
          ),
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/jobs' },
            'Jobs'
          ),
          _react2.default.createElement('div', { className: 'desert' }),
          search,
          loggedInExtras,
          personalInnards
        )
      );
    }
  }]);

  return Navigation;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var booted = _ref.booted,
      auth = _ref.auth,
      user = _ref.user;

  return { booted: booted, auth: auth, user: user };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Navigation);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/Navigation.js
// module id = 130
// module chunks = 0